import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

const NOTIFICATION_RECIPIENT = 'deandupreez1@gmail.com';

const stripNewlines = (s) => String(s).replace(/[\r\n]/g, ' ').slice(0, 200);

export const submitContactForm = async (formData) => {
  try {
    // Honeypot: bots fill hidden fields. Pretend success, write nothing.
    if (formData.website) {
      return { success: true, id: null, message: 'Thank you for your enquiry!' };
    }

    if (!formData.name || !formData.email || !formData.currentSituation) {
      throw new Error('Please fill in all required fields');
    }

    const contactData = {
      name: formData.name.trim(),
      company: formData.company?.trim() || '',
      role: formData.role?.trim() || '',
      email: formData.email.trim(),
      currentSituation: formData.currentSituation.trim(),
      timestamp: serverTimestamp(),
      createdAt: new Date().toISOString(),
      source: 'website_contact_form',
      status: 'new',
      userAgent: navigator.userAgent,
      referrer: document.referrer,
      url: window.location.href
    };

    const docRef = await addDoc(collection(db, 'contacts'), contactData);

    try {
      const subjectName = stripNewlines(contactData.name);
      const subjectCompany = contactData.company ? ' · ' + stripNewlines(contactData.company) : '';
      const body =
        `${contactData.name} (${contactData.email})\n` +
        (contactData.role ? `Role: ${contactData.role}\n` : '') +
        (contactData.company ? `Company: ${contactData.company}\n` : '') +
        `\n${contactData.currentSituation}`;

      await addDoc(collection(db, 'mail'), {
        to: NOTIFICATION_RECIPIENT,
        message: {
          subject: `New enquiry — ${subjectName}${subjectCompany}`,
          text: body,
        },
      });
    } catch (mailError) {
      console.error('Mail notification write failed (contact still saved):', mailError);
    }

    return {
      success: true,
      id: docRef.id,
      message: 'Thank you for your enquiry! We\'ll be in touch within 24 hours.'
    };
    
  } catch (error) {
    console.error('Error submitting contact form:', error);
    
    if (error.code === 'permission-denied') {
      throw new Error('Unable to submit form. Please try again or email us directly.');
    } else if (error.code === 'unavailable') {
      throw new Error('Service temporarily unavailable. Please try again in a few moments.');
    } else if (error.message.includes('required fields')) {
      throw error;
    } else {
      throw new Error('Failed to submit form. Please try again or email us directly.');
    }
  }
};